var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          staticClass: "section top",
          staticStyle: { "flex-direction": "row", "min-width": "1600px" },
          attrs: { disabled: _vm.readonly }
        },
        [
          _c(
            "el-checkbox",
            {
              attrs: { no: "1" },
              on: {
                change: function($event) {
                  return _vm.loadingTerm_Change("warehousing")
                }
              },
              model: {
                value: _vm.job.warehousing,
                callback: function($$v) {
                  _vm.$set(_vm.job, "warehousing", $$v)
                },
                expression: "job.warehousing"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Storage")))]
          ),
          _c(
            "el-checkbox",
            {
              attrs: { no: "2" },
              model: {
                value: _vm.job.comercialInspectation,
                callback: function($$v) {
                  _vm.$set(_vm.job, "comercialInspectation", $$v)
                },
                expression: "job.comercialInspectation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.CommodityInspection")))]
          )
        ],
        1
      ),
      _c(
        "tab-ae-booking-UICustom-layout",
        { attrs: { "element-blocks": _vm.elementBlocks } },
        [
          _vm.elementDict.jobNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "jobNo" }, slot: "jobNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.jobNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.jobNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "job-no-color",
                    attrs: { no: "3", disabled: true },
                    model: {
                      value: _vm.job.jobNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "jobNo", $$v)
                      },
                      expression: "job.jobNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.warehouseNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "warehouseNo" }, slot: "warehouseNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.warehouseNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.warehouseNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "4" },
                    model: {
                      value: _vm.job.warehouseNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "warehouseNo", $$v)
                      },
                      expression: "job.warehouseNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quotationNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "quotationNo" }, slot: "quotationNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quotationNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quotationNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    staticClass: "input2",
                    attrs: {
                      no: "5",
                      value: _vm.job.quotationNo,
                      disabled: true
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerRefNo.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerRefNo" }, slot: "customerRefNo" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerRefNo.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-input", {
                    attrs: { disabled: _vm.readonly, no: "6", trim: true },
                    model: {
                      value: _vm.job.customerRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customerRefNo", $$v)
                      },
                      expression: "job.customerRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerId" }, slot: "customerId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerId.label
                    },
                    slot: "label"
                  }),
                  _vm.accountObjectControlMode === 2
                    ? _c("cargo-sales-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "7",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.txtCustomerId_changeHandler(p)
                            _vm.clearPoNo()
                          }
                        }
                      })
                    : _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "7",
                          disabled:
                            !(!_vm.job.mbl && _vm.electricBusinessBtnEnable) ||
                            _vm.readonly,
                          "method-params": { customer: true, active: true },
                          "check-credit": true,
                          job: _vm.job,
                          "default-value": _vm.job.customerId || "",
                          "static-options": _vm.customerCmpList,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          change: function(p) {
                            _vm.txtCustomerId_changeHandler(p)
                            _vm.clearPoNo()
                          }
                        }
                      })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customerContact.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customerContact" }, slot: "customerContact" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customerContact.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customerContact.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        no: "8",
                        disabled:
                          !_vm.electricBusinessBtnEnable || _vm.readonly,
                        filterable: "",
                        "allow-create": true,
                        placeholder: ""
                      },
                      on: { change: _vm.tfLinkman_closeHandler },
                      model: {
                        value: _vm.job.customerContact,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "customerContact", $$v)
                        },
                        expression: "job.customerContact"
                      }
                    },
                    _vm._l(_vm.contactList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.contactPerson,
                          value: item.contactPerson
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactTelephone.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "contactTelephone" },
                  slot: "contactTelephone"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactTelephone.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactTelephone.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "9",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactTelephone,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactTelephone", $$v)
                      },
                      expression: "job.contactTelephone"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactFax.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "contactFax" }, slot: "contactFax" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactFax.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactFax.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "10",
                      disabled: !_vm.electricBusinessBtnEnable || _vm.readonly,
                      maxlength: "32"
                    },
                    model: {
                      value: _vm.job.contactFax,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "contactFax", $$v)
                      },
                      expression: "job.contactFax"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sales.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "sales" }, slot: "sales" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.sales.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.sales.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "11",
                      disabled:
                        _vm.lockSales ||
                        !(
                          !_vm.job.trustFromJob &&
                          _vm.electricBusinessBtnEnable &&
                          (!_vm.validateCustomerSales ||
                            (_vm.isSpecifiedSalesBusiness &&
                              _vm.validateCustomerSales))
                        ) ||
                        _vm.readonly,
                      "method-params": {
                        officeId: _vm.salesOfficeCheck
                          ? _vm.$store.getters.currentOfficeId
                          : "",
                        category: "role",
                        shape: "sales"
                      },
                      "default-value": _vm.job.sales || "",
                      "static-options": _vm.salesList,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { change: _vm.txtSales_changeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.txtSalesOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "txtSalesOffice" }, slot: "txtSalesOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.txtSalesOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.txtSalesOffice.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      no: "12",
                      disabled: true,
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    model: {
                      value: _vm.txtSalesOffice,
                      callback: function($$v) {
                        _vm.txtSalesOffice = $$v
                      },
                      expression: "txtSalesOffice"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.salesDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "salesDepartment" }, slot: "salesDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.salesDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.salesDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-new-select", {
                    attrs: {
                      no: "salesDepartment",
                      disabled: !_vm.job.sales || _vm.readonly,
                      enables: true,
                      "sales-id": Number(_vm.job.sales),
                      "office-id": Number(_vm.job.salesOffice),
                      "department-id": Number(_vm.job.salesDepartment)
                    },
                    on: { change: _vm.departmentChargeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csr.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csr" }, slot: "csr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csr.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.csr.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "13",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "csr",
                        officeId: _vm.job.opOffice
                      },
                      "default-value": _vm.job.csr || "",
                      "static-options": _vm.userPortRoleData.csr || _vm.csrList,
                      placeholder: " "
                    },
                    on: { change: _vm.csrChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.overseaOp.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "overseaOp" }, slot: "overseaOp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.overseaOp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.overseaOp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "overseaOp",
                    staticClass: "input2",
                    attrs: {
                      no: "overseaOp",
                      disabled: _vm.readonly,
                      placeholder: " ",
                      "default-value": _vm.job.overseaOp || "",
                      "method-params": { category: "role", shape: "overseaOp" },
                      "static-options": _vm.isHc
                        ? null
                        : _vm.userPortRoleData.overseaOp ||
                          _vm.overseaAgentUsersList,
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.job.overseaOp = p.value
                        _vm.OverseaCustomerUtils.overseaOpChangeHandler(
                          _vm.view,
                          p
                        )
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.operateType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "operateType" }, slot: "operateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.operateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.operateType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "14",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type":
                        _vm.TYPE_NAMES
                          .local_cache_AirExportConstants$BUSINESS_MODELS,
                      "default-value": _vm.job.operateType,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.operateType = p.value
                        _vm.onOperateTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.op.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "op" }, slot: "op" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.op.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.op.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "15",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "op",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.op || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.op
                    },
                    on: { change: _vm.txtOPChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opDepartment" }, slot: "opDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    attrs: {
                      no: "16",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "office-id": _vm.job.opOffice,
                      "department-id": _vm.job.opDepartment,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.opDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.opOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "opOffice" }, slot: "opOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.opOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.opOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "17",
                      disabled: _vm.isEntrustOrder() || _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.opOffice || "",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.opOffice = p.value
                        _vm.opOfficeChargeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSalesId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSalesId" }, slot: "cargoSalesId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSalesId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSalesId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "18",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "salesOfGoods"
                      },
                      "default-value": _vm.job.cargoSalesId || "",
                      "static-options": _vm.cargoSalesList,
                      placeholder: " "
                    },
                    on: { change: _vm.cargoSalesChargeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dc.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dc" }, slot: "dc" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dc.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.dc.label },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "104",
                      disabled: Boolean(_vm.job.trustFromJob) || _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "doc",
                        officeId: _vm.$store.getters.currentOfficeId
                      },
                      "default-value": _vm.job.dc || "",
                      "static-options": _vm.userPortRoleData.doc || _vm.dcList,
                      placeholder: " "
                    },
                    on: { change: _vm.dcChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.siteOP.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "siteOP" }, slot: "siteOP" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.siteOP.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.siteOP.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "19",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "siteOp"
                      },
                      "default-value": _vm.job.siteOP || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.siteOp
                    },
                    on: {
                      change: function(p) {
                        _vm.JobUtils.siteOpChangeHandler(_vm.job, p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.planner.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "planner" }, slot: "planner" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.planner.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.planner.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    attrs: {
                      no: "20",
                      disabled: _vm.readonly,
                      "method-params": {
                        category: "role",
                        shape: "airline",
                        officeId:
                          _vm.currentOffice.code === "HB"
                            ? null
                            : _vm.currentOffice.officeId
                      },
                      "default-value": _vm.job.planner || "",
                      placeholder: " ",
                      "static-options": _vm.userPortRoleData.airline
                    },
                    on: { change: _vm.txtPlannerChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrDepartment" }, slot: "csrDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "csrDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.csrOffice),
                      enables: true,
                      "department-id": Number(_vm.job.csrDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.csrDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.csrOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "csrOffice" }, slot: "csrOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.csrOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.csrOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "csrOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.csrOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.csrOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcDepartment.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcDepartment" }, slot: "dcDepartment" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcDepartment.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "dcDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.dcOffice),
                      enables: true,
                      "department-id": Number(_vm.job.dcDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.dcDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dcOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "dcOffice" }, slot: "dcOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dcOffice.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dcOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "dcOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.dcOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.dcOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.poNo.visible
            ? _c(
                "el-form-item",
                {
                  class: _vm.poNoRed ? "poNoClass" : "",
                  attrs: { slot: "poNo" },
                  slot: "poNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.poNo.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.poNo.label },
                    slot: "label"
                  }),
                  !_vm.openProjectConfig
                    ? _c("el-input", {
                        attrs: { disabled: _vm.readonly, no: "21" },
                        model: {
                          value: _vm.job.poNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "poNo", $$v)
                          },
                          expression: "job.poNo"
                        }
                      })
                    : _vm._e(),
                  _vm.openProjectConfig
                    ? _c("cargo-project-select", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "22",
                          "default-value": _vm.job.poNo,
                          "customer-id": _vm.job.customerId,
                          "is-linked": _vm.isProjectLinkedCustomer
                        },
                        on: { change: _vm.changeProject }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerDepartment &&
          _vm.elementDict.plannerDepartment.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "plannerDepartment" },
                  slot: "plannerDepartment"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerDepartment.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerDepartment.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-department-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "plannerDepartment",
                      disabled: _vm.readonly,
                      "office-id": Number(_vm.job.plannerOffice),
                      enables: true,
                      "department-id": Number(_vm.job.plannerDepartment)
                    },
                    on: {
                      change: function(p) {
                        _vm.job.plannerDepartment = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.plannerOffice && _vm.elementDict.plannerOffice.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "plannerOffice" }, slot: "plannerOffice" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.plannerOffice.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.plannerOffice.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    staticClass: "input2",
                    attrs: {
                      no: "plannerOffice",
                      disabled: true,
                      "select-type": _vm.TYPE_NAMES.basic_data_Office,
                      filterable: "",
                      "default-value": _vm.job.plannerOffice || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.plannerOffice = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectName.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectName" }, slot: "projectName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectName.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { no: "23", disabled: true },
                    model: {
                      value: _vm.job.projectName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectName", $$v)
                      },
                      expression: "job.projectName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.projectBatch.visible && _vm.openProjectConfig
            ? _c(
                "el-form-item",
                { attrs: { slot: "projectBatch" }, slot: "projectBatch" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.projectBatch.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.projectBatch.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "24" },
                    model: {
                      value: _vm.job.projectBatch,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "projectBatch", $$v)
                      },
                      expression: "job.projectBatch"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isAddUserDefinedRoles
            ? [
                _vm.elementDict.userDefinedRoleId1.visible
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "userDefinedRoleId1" },
                        slot: "userDefinedRoleId1"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.userDefinedRoleId1.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.userDefinedRoleId1.label
                          },
                          slot: "label"
                        }),
                        _c("cargo-user-select", {
                          attrs: {
                            no: "25",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole1"
                            },
                            "default-value": _vm.job.userDefinedRoleId1 || "",
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole1
                          },
                          on: { change: _vm.userDefinedRoleId1Handler }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.elementDict.userDefinedRoleId2.visible
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { slot: "userDefinedRoleId2" },
                        slot: "userDefinedRoleId2"
                      },
                      [
                        _c("line-label", {
                          class: _vm.elementDict.userDefinedRoleId2.isRequire
                            ? "blue"
                            : "",
                          attrs: {
                            slot: "label",
                            label: _vm.elementDict.userDefinedRoleId2.label
                          },
                          slot: "label"
                        }),
                        _c("cargo-user-select", {
                          attrs: {
                            no: "26",
                            disabled: _vm.readonly,
                            "method-params": {
                              officeId: _vm.$store.getters.currentOfficeId,
                              category: "role",
                              shape: "userDefinedRole2"
                            },
                            "default-value": _vm.job.userDefinedRoleId2 || "",
                            placeholder: _vm.$t("SeaExport.RequiredItem"),
                            "static-options":
                              _vm.userPortRoleData.userDefinedRole2
                          },
                          on: { change: _vm.userDefinedRoleId2Handler }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId3 &&
          _vm.elementDict.userDefinedRoleId3.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId3" },
                  slot: "userDefinedRoleId3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId3.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId3",
                    attrs: {
                      no: "userDefinedRoleId3",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole3"
                      },
                      "default-value": _vm.job.userDefinedRoleId3 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole3
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId3Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId4 &&
          _vm.elementDict.userDefinedRoleId4.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId4" },
                  slot: "userDefinedRoleId4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId4.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId4",
                    attrs: {
                      no: "userDefinedRoleId4",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole4"
                      },
                      "default-value": _vm.job.userDefinedRoleId4 || "",
                      "merge-load": true,
                      "static-options": _vm.userPortRoleData.userDefinedRole4
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId4Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId5 &&
          _vm.elementDict.userDefinedRoleId5.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId5" },
                  slot: "userDefinedRoleId5"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId5.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId5.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId5",
                    attrs: {
                      no: "userDefinedRoleId5",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole5"
                      },
                      "default-value": _vm.job.userDefinedRoleId5 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId5Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId6 &&
          _vm.elementDict.userDefinedRoleId6.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId6" },
                  slot: "userDefinedRoleId6"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId6.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId6.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId6",
                    attrs: {
                      no: "userDefinedRoleId6",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole6"
                      },
                      "default-value": _vm.job.userDefinedRoleId6 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId6Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId7 &&
          _vm.elementDict.userDefinedRoleId7.visible &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId7" },
                  slot: "userDefinedRoleId7"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId7.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId7.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId7",
                    attrs: {
                      no: "userDefinedRoleId7",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole7"
                      },
                      "default-value": _vm.job.userDefinedRoleId7 || "",
                      "merge-load": true
                    },
                    on: {
                      change: function(p) {
                        _vm.userDefinedRoleId7Handler(p)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedRoleId8 &&
          _vm.elementDict.userDefinedRoleId8.viewable &&
          _vm.isAddUserDefinedRoles
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "userDefinedRoleId8" },
                  slot: "userDefinedRoleId8"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedRoleId8.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedRoleId8.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-user-select", {
                    ref: "userDefinedRoleId8",
                    attrs: {
                      no: "userDefinedRoleId8",
                      disabled: _vm.readonly,
                      "method-params": {
                        officeId: _vm.$store.getters.currentOfficeId,
                        category: "role",
                        shape: "userDefinedRole8"
                      },
                      "default-multiple-value": _vm.toNumArray(
                        _vm.job.userDefinedRoleId8
                      ),
                      multiple: true,
                      "merge-load": true,
                      placeholder: _vm.readonly ? " " : ""
                    },
                    on: {
                      change: function(p) {
                        _vm.job.userDefinedRoleId8 = _vm.toTxt(p.value)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.shipper.visible,
                  expression: "elementDict.shipper.visible"
                }
              ],
              staticStyle: { "margin-right": "10px" },
              attrs: {
                slot: "shipper",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "shipper"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.shipper.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.shipper.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "28",
                      disabled: _vm.readonly,
                      "method-params": { shipper: true, active: true },
                      "default-value": _vm.job.shipperId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateShipperList
                        : null
                    },
                    on: { change: _vm.shipperChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "29",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "shipperLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "30",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "shipperLine" + i,
                            i + 1 > 7 ? null : "shipperLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Shipper"),
                            _vm.mergeShipperLine(),
                            _vm.splitShipperLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["shipperLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "shipperLine" + i, $$v)
                        },
                        expression: "job['shipperLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.consignee.visible,
                  expression: "elementDict.consignee.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "consignee",
                "label-width": "65px",
                "label-position": "left"
              },
              slot: "consignee"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.consignee.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.consignee.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "52",
                      disabled: _vm.readonly,
                      "method-params": { consignee: true, active: true },
                      "default-value": _vm.job.consigneeId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateConsigneeList
                        : null
                    },
                    on: { change: _vm.consigneeChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "53",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "consigneeLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "54",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "consigneeLine" + i,
                            i + 1 > 7 ? null : "consigneeLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.Consignee"),
                            _vm.mergeConsigneeLine(),
                            _vm.splitConsigneeLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["consigneeLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "consigneeLine" + i, $$v)
                        },
                        expression: "job['consigneeLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.notify.visible,
                  expression: "elementDict.notify.visible"
                }
              ],
              staticStyle: { "margin-right": "20px" },
              attrs: {
                slot: "notify",
                "label-width": "50px",
                "label-position": "left"
              },
              slot: "notify"
            },
            [
              _c(
                "el-form-item",
                [
                  _c("line-label", {
                    class: _vm.elementDict.notify.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.notify.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { display: "inline-block", width: "196px" },
                    attrs: {
                      no: "72",
                      disabled: _vm.readonly,
                      "method-params": { notify: true, active: true },
                      "default-value": _vm.job.notifyId || "",
                      placeholder: " ",
                      "static-options": _vm.hasChooseOwnTransceiverPermission
                        ? _vm.privateNotifyList
                        : null
                    },
                    on: { change: _vm.notifyChange }
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: {
                        no: "73",
                        disabled: _vm.readonly,
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          _vm.billAddressDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.CodeSearching")))]
                  )
                ],
                1
              ),
              _vm._l(7, function(i) {
                return _c(
                  "el-form-item",
                  { key: i, attrs: { "label-width": "0" } },
                  [
                    _c("cargo-input", {
                      ref: "notifyLine" + i,
                      refInFor: true,
                      attrs: {
                        disabled: _vm.readonly,
                        no: "74",
                        "auto-uppercase": true
                      },
                      on: {
                        change: function() {
                          return _vm.wrapAddr(
                            _vm.job,
                            "notifyLine" + i,
                            i + 1 > 7 ? null : "notifyLine" + (i + 1),
                            200
                          )
                        }
                      },
                      nativeOn: {
                        dblclick: function($event) {
                          _vm.showAdvanceTextDialog(
                            _vm.$t("SeaExport.NotifyParty"),
                            _vm.mergeNotifyLine(),
                            _vm.splitNotifyLine,
                            true
                          )
                        }
                      },
                      model: {
                        value: _vm.job["notifyLine" + i],
                        callback: function($$v) {
                          _vm.$set(_vm.job, "notifyLine" + i, $$v)
                        },
                        expression: "job['notifyLine'+i]"
                      }
                    })
                  ],
                  1
                )
              })
            ],
            2
          ),
          _vm.elementDict.alsoNotify.visible
            ? _c(
                "div",
                { attrs: { slot: "alsoNotify" }, slot: "alsoNotify" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.alsoNotify.isRequire ? "blue" : "",
                    staticStyle: {
                      display: "inline-block",
                      "line-height": "28px",
                      "padding-bottom": "5px"
                    },
                    attrs: { label: _vm.elementDict.alsoNotify.label }
                  }),
                  _c("br"),
                  _c("cargo-textarea", {
                    staticClass: "also-notify",
                    attrs: {
                      no: "87",
                      type: "textarea",
                      rows: 12,
                      disabled: _vm.readonly
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.alsoNotify.label,
                          _vm.job.alsoNotify,
                          function(val) {
                            _vm.job.alsoNotify = val
                          },
                          true,
                          { warningCount: 45, maxChar: 0 }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.alsoNotify,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "alsoNotify", $$v)
                      },
                      expression: "job.alsoNotify"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.hsCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "hsCode" }, slot: "hsCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.hsCode.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.hsCode.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "hsCode",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.hsCode.labe,
                          _vm.job.hsCode,
                          function(val) {
                            _vm.job.hsCode = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.hsCode,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "hsCode", $$v)
                      },
                      expression: "job.hsCode"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.etd.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "etd" }, slot: "etd" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.etd.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.etd.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "31",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: "",
                      placeholder: _vm.$t("SeaExport.RequiredItem")
                    },
                    on: { input: _vm.etdChange },
                    model: {
                      value: _vm.job.etd,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "etd", $$v)
                      },
                      expression: "job.etd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.eta.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "eta" }, slot: "eta" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.eta.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.eta.label },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      no: "32",
                      disabled: _vm.readonly,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.eta,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "eta", $$v)
                      },
                      expression: "job.eta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          _vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "div",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("micro-app", {
                    attrs: {
                      name: "child-operation-date-ae",
                      url:
                        _vm.$store.getters.frontEndPluginUrl +
                        "/operationDateItem",
                      "router-mode": "pure",
                      destroy: ""
                    },
                    on: { datachange: _vm.operationDateDataChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customsDate &&
          _vm.elementDict.customsDate.visible &&
          !_vm.$store.getters.enableFrontEndPlugin
            ? _c(
                "el-form-item",
                { attrs: { slot: "customsDate" }, slot: "customsDate" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customsDate.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customsDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      no: "customsDate",
                      disabled: _vm.readonly,
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.customsDate,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "customsDate", $$v)
                      },
                      expression: "job.customsDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.dispatchingPlace.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "dispatchingPlace" },
                  slot: "dispatchingPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.dispatchingPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.dispatchingPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "33" },
                    model: {
                      value: _vm.job.dispatchingPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "dispatchingPlace", $$v)
                      },
                      expression: "job.dispatchingPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.loadingPortCode.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "loadingPortCode" }, slot: "loadingPortCode" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingPortCode.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingPortCode.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        width: "100%"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "60px" },
                        attrs: { no: "34", disabled: true },
                        model: {
                          value: _vm.job.loadingPortCode,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "loadingPortCode", $$v)
                          },
                          expression: "job.loadingPortCode"
                        }
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "35",
                          disabled: _vm.readonly,
                          filterable: "",
                          "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                          "default-value": _vm.job.loadingPortCode,
                          placeholder: _vm.$t("SeaExport.RequiredItem")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.loadingPortCode = p.value
                            _vm.onLoadingPortCodeChange()
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPortCode.visible
            ? _c(
                "template",
                { slot: "destinationPortCode" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.destinationPortCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.destinationPortCode.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            width: "100%"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "60px" },
                            attrs: { no: "36", disabled: true },
                            model: {
                              value: _vm.job.destinationPortCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPortCode", $$v)
                              },
                              expression: "job.destinationPortCode"
                            }
                          }),
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "37",
                              disabled: _vm.readonly,
                              filterable: "",
                              "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                              "default-value": _vm.job.destinationPortCode,
                              placeholder: _vm.$t("SeaExport.RequiredItem")
                            },
                            on: {
                              parentCallBack: _vm.destinationPortCodeChange
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: " " } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "line-height": "28px" },
                            attrs: { disabled: _vm.readonly, no: "38" },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "100%",
                              "margin-left": "10px"
                            },
                            attrs: {
                              no: "39",
                              disabled: !_vm.job.transfering || _vm.readonly,
                              type: "primary"
                            },
                            on: { click: _vm.showTransitPortDialog }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EnterTransitInfo")))]
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationPlace.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationPlace" },
                  slot: "destinationPlace"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationPlace.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationPlace.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "40" },
                    on: {
                      input: function(val) {
                        return (_vm.job.destinationPlace = _vm.StrUtils.toUpperCase(
                          val
                        ))
                      }
                    },
                    model: {
                      value: _vm.job.destinationPlace,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "destinationPlace", $$v)
                      },
                      expression: "job.destinationPlace"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoType" }, slot: "cargoType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "41",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_CargoType,
                      "method-params": { air: true },
                      "default-value": _vm.job.cargoType,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoType = p.value
                        _vm.onCargoTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.loadingTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "loadingTerm" }, slot: "loadingTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.loadingTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.loadingTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "42",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type":
                        _vm.TYPE_NAMES
                          .local_cache_AirExportConstants$SUFFY_TYPES,
                      "tag-name": _vm.isZh ? "chineseName" : "englishName",
                      "default-value": _vm.job.loadingTerm,
                      placeholder: _vm.$t("Message.PleaseSelect")
                    },
                    on: { parentCallBack: _vm.loadingTermChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoTerminalOperation &&
          _vm.elementDict.cargoTerminalOperation.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoTerminalOperation" },
                  slot: "cargoTerminalOperation"
                },
                [
                  _c("line-label", {
                    class:
                      _vm.elementDict.cargoTerminalOperation &&
                      _vm.elementDict.cargoTerminalOperation.isRequire
                        ? "blue"
                        : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.cargoTerminalOperation &&
                        _vm.elementDict.cargoTerminalOperation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "cargoTerminalOperation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                      "method-params": { dataType: 0, deletionFlag: false },
                      filterable: "",
                      clearable: true,
                      "default-value": _vm.job.cargoTerminalOperation
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoTerminalOperation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedDeliveryDate &&
          _vm.elementDict.estimatedDeliveryDate.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "estimatedDeliveryDate" },
                  slot: "estimatedDeliveryDate"
                },
                [
                  _c("line-label", {
                    class:
                      _vm.elementDict.estimatedDeliveryDate &&
                      _vm.elementDict.estimatedDeliveryDate.isRequire
                        ? "blue"
                        : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.estimatedDeliveryDate &&
                        _vm.elementDict.estimatedDeliveryDate.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: !_vm.isEdit || !_vm.job.cargoTerminalOperation,
                      no: "estimatedDeliveryDate",
                      type: "date",
                      "value-format": "yyyy-MM-dd",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.estimatedDeliveryDate,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "estimatedDeliveryDate", $$v)
                      },
                      expression: "job.estimatedDeliveryDate"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermMBL.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermMBL" }, slot: "paymentTermMBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermMBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermMBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "43",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                      "default-value": _vm.job.paymentTermMBL,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.paymentTermMBL = _vm.data.value
                        _vm.portChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.paymentTermHBL.visible && _vm.job.operateType !== 2
            ? _c(
                "el-form-item",
                { attrs: { slot: "paymentTermHBL" }, slot: "paymentTermHBL" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.paymentTermHBL.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.paymentTermHBL.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "44",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_PaymentTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.paymentTermHBL,
                      "allow-create": true
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.paymentTermHBL = p.value
                        _vm.portChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoSource.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cargoSource" }, slot: "cargoSource" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoSource.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoSource.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "45",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.local_cache_CargoSource,
                      "default-value": _vm.job.cargoSource,
                      clearable: false
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.cargoSource = p.value
                        _vm.selectFieldChangeHandler()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.agentRefNo.visible && _vm.job.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "agentRefNo", id: "agentRefNo" },
                  slot: "agentRefNo"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.agentRefNo.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.agentRefNo.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "agentRefNo" },
                    model: {
                      value: _vm.job.agentRefNo,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "agentRefNo", $$v)
                      },
                      expression: "job.agentRefNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customJobType.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "customJobType" }, slot: "customJobType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.customJobType.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.customJobType.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    ref: "customJobType",
                    attrs: {
                      no: "46",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_CutomJobType,
                      "method-params": { type: _vm.job.lob, active: true },
                      "default-value": _vm.job.customJobType,
                      placeholder: _vm.$t("Message.PleaseSelect")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.customJobType = p.value
                        _vm.onCustomJobTypeChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.destinationAgent.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "destinationAgent" },
                  slot: "destinationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.destinationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.destinationAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "47",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      filterable: "",
                      "method-params": { overseaAgent: true, active: true },
                      "default-value": _vm.job.destinationAgent || "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.txtDestinationAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.designationAgent.visible &&
          _vm.job.cargoSource === "NC"
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "designationAgent" },
                  slot: "designationAgent"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.designationAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.designationAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "48",
                      disabled: _vm.readonly,
                      "method-params": { designationAgent: true, active: true },
                      "check-credit": true,
                      job: _vm.job,
                      "default-value": _vm.job.designationAgent || "",
                      "tag-name": "englishName",
                      placeholder: " "
                    },
                    on: { change: _vm.txtDesignationAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingAgent.visible && _vm.bookingAgentVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingAgent" }, slot: "bookingAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingAgent.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "49",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": {
                        bookingAgent: true,
                        companyLob: "airExport",
                        active: true
                      },
                      "default-value": _vm.job.bookingAgent || "",
                      placeholder: " "
                    },
                    on: { parentCallBack: _vm.bookingAgentChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carrierId.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "carrierId" }, slot: "carrierId" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carrierId.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carrierId.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "50",
                      disabled: _vm.readonly,
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true, active: true },
                      "default-value": _vm.job.carrierId || "",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.carrierId = p.value || 0
                        _vm.onCarrierIdChange()
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.voyageFlight.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "voyageFlight" }, slot: "voyageFlight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.voyageFlight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.voyageFlight.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: { disabled: _vm.readonly, no: "51" },
                    on: { change: _vm.voyageFlightCheckHandler },
                    model: {
                      value: _vm.job.voyageFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "voyageFlight", $$v)
                      },
                      expression: "job.voyageFlight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.quantityContract.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "quantityContract" },
                  slot: "quantityContract"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.quantityContract.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.quantityContract.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "55",
                      precision: 0,
                      min: 0
                    },
                    model: {
                      value: _vm.job.quantityContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "quantityContract", $$v)
                      },
                      expression: "job.quantityContract"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.weightContract.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "weightContract" }, slot: "weightContract" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.weightContract.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.weightContract.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.openImperial,
                        expression: "openImperial"
                      }
                    ],
                    attrs: {
                      disabled: _vm.readonly,
                      no: "weightContractImperial",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        return _vm.doWeightChangeHandler(true)
                      }
                    },
                    model: {
                      value: _vm.job.weightContractImperial,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightContractImperial", $$v)
                      },
                      expression: "job.weightContractImperial"
                    }
                  }),
                  _c("auto-number-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.openImperial,
                        expression: "!openImperial"
                      }
                    ],
                    attrs: {
                      disabled: _vm.readonly,
                      no: "56",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        return _vm.doWeightChangeHandler(false)
                      }
                    },
                    model: {
                      value: _vm.job.weightContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "weightContract", $$v)
                      },
                      expression: "job.weightContract"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cubageContract.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "cubageContract" }, slot: "cubageContract" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cubageContract.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cubageContract.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.openImperial,
                        expression: "openImperial"
                      }
                    ],
                    attrs: {
                      disabled: _vm.readonly,
                      no: "cubAgeContractImperial",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        return _vm.doCuAgeChangeHandler(true)
                      }
                    },
                    model: {
                      value: _vm.job.cubAgeContractImperial,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubAgeContractImperial", $$v)
                      },
                      expression: "job.cubAgeContractImperial"
                    }
                  }),
                  _c("auto-number-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.openImperial,
                        expression: "!openImperial"
                      }
                    ],
                    attrs: {
                      disabled: _vm.readonly,
                      no: "57",
                      precision: 3,
                      min: 0
                    },
                    on: {
                      change: function($event) {
                        return _vm.doCuAgeChangeHandler(false)
                      }
                    },
                    model: {
                      value: _vm.job.cubageContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cubageContract", $$v)
                      },
                      expression: "job.cubageContract"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.densityContract.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "densityContract" }, slot: "densityContract" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.densityContract.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.densityContract.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "58",
                      precision: 3,
                      min: 0
                    },
                    model: {
                      value: _vm.job.densityContract,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "densityContract", $$v)
                      },
                      expression: "job.densityContract"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.packing.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "packing" }, slot: "packing" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.packing.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.packing.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "59",
                      disabled: _vm.readonly,
                      "default-value": _vm.job.packing,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.packing = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.pbProportion.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "pbProportion" }, slot: "pbProportion" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.pbProportion.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.pbProportion.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "100%" } },
                    [
                      [
                        _vm.splitBubbleCollectionFormat
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  value: _vm.job.pbProportion || "",
                                  disabled: _vm.readonly,
                                  no: "60",
                                  clearable: "",
                                  filterable: !_vm.pbProportionCheck,
                                  "allow-create": !_vm.pbProportionCheck
                                },
                                on: {
                                  focus: _vm.onPbProportionFocus,
                                  input: function(val) {
                                    _vm.job.pbProportion = val
                                  }
                                }
                              },
                              _vm._l(_vm.SPLIT_BUBBLE_COLLECT_ITEMS, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$getLangColumn(item),
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          : [
                              _c("el-input-number", {
                                staticStyle: { "margin-right": "0px" },
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "60",
                                  "controls-position": "right",
                                  precision: 0,
                                  min: 0,
                                  max: 100
                                },
                                model: {
                                  value: _vm.job.pbProportion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "pbProportion", $$v)
                                  },
                                  expression: "job.pbProportion"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "line-height": "28px" } },
                                [_vm._v("%")]
                              )
                            ]
                      ],
                      _c(
                        "span",
                        {
                          class: _vm.elementDict.pbProportion.isRequire
                            ? "blue"
                            : "",
                          staticStyle: {
                            "padding-left": "10px",
                            "padding-right": "5px",
                            "line-height": "28px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.pbProportion2")))]
                      ),
                      [
                        _vm.splitBubbleCollectionFormat
                          ? _c(
                              "el-select",
                              {
                                attrs: {
                                  value: _vm.job.pbProportion2 || "",
                                  disabled: _vm.readonly,
                                  no: "61",
                                  clearable: "",
                                  filterable: !_vm.pbProportion2Check,
                                  "allow-create": !_vm.pbProportion2Check
                                },
                                on: {
                                  focus: _vm.onPbProportion2Focus,
                                  input: function(val) {
                                    _vm.job.pbProportion2 = val
                                  }
                                }
                              },
                              _vm._l(_vm.SPLIT_BUBBLE_COLLECT_ITEMS, function(
                                item,
                                index
                              ) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: _vm.$getLangColumn(item),
                                    value: item.code
                                  }
                                })
                              }),
                              1
                            )
                          : [
                              _c("el-input-number", {
                                attrs: {
                                  disabled: _vm.readonly,
                                  no: "61",
                                  "controls-position": "right",
                                  precision: 0,
                                  min: 0,
                                  max: 100
                                },
                                model: {
                                  value: _vm.job.pbProportion2,
                                  callback: function($$v) {
                                    _vm.$set(_vm.job, "pbProportion2", $$v)
                                  },
                                  expression: "job.pbProportion2"
                                }
                              }),
                              _c(
                                "span",
                                { staticStyle: { "line-height": "28px" } },
                                [_vm._v("%")]
                              )
                            ]
                      ]
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insideQuantity.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "insideQuantity" }, slot: "insideQuantity" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insideQuantity.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insideQuantity.label
                    },
                    slot: "label"
                  }),
                  _c("auto-number-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "62",
                      precision: 0,
                      min: 0
                    },
                    model: {
                      value: _vm.job.insideQuantity,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "insideQuantity", $$v)
                      },
                      expression: "job.insideQuantity"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.chargeWeight &&
          _vm.elementDict.chargeWeight.visible &&
          _vm.openImperial
            ? _c(
                "el-form-item",
                { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.chargeWeight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.chargeWeight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "100%" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "auto", "flex-grow": "1" },
                        attrs: {
                          disabled: true,
                          no: "chargeWeightImperial",
                          controls: false,
                          precision: 3
                        },
                        model: {
                          value: _vm.job.chargeWeightImperial,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "chargeWeightImperial", $$v)
                          },
                          expression: "job.chargeWeightImperial"
                        }
                      }),
                      _c("span", { staticStyle: { "line-height": "28px" } }, [
                        _vm._v("LB")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.chargeWeight &&
          _vm.elementDict.chargeWeight.visible &&
          !_vm.openImperial
            ? _c(
                "el-form-item",
                { attrs: { slot: "chargeWeight" }, slot: "chargeWeight" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.chargeWeight.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.chargeWeight.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex", width: "100%" } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "auto", "flex-grow": "1" },
                        attrs: {
                          disabled: _vm.readonly,
                          no: "63",
                          controls: false,
                          precision: 3
                        },
                        model: {
                          value: _vm.job.chargeWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "chargeWeight", $$v)
                          },
                          expression: "job.chargeWeight"
                        }
                      }),
                      _c("span", { staticStyle: { "line-height": "28px" } }, [
                        _vm._v("M/T")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.insidePacking.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "insidePacking" }, slot: "insidePacking" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.insidePacking.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.insidePacking.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-packing-select", {
                    attrs: {
                      no: "64",
                      disabled: _vm.readonly,
                      "default-value": _vm.job.insidePacking,
                      placeholder: " "
                    },
                    on: {
                      change: function(p) {
                        _vm.job.insidePacking = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.measurements.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "measurements" }, slot: "measurements" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.measurements.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.measurements.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "65",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Size"),
                          _vm.job.measurements,
                          function(val) {
                            _vm.job.measurements = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.measurements,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "measurements", $$v)
                      },
                      expression: "job.measurements"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.frontEndWarehouseOperation &&
          _vm.elementDict.frontEndWarehouseOperation.slaveVisible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "frontEndWarehouseOperation" },
                  slot: "frontEndWarehouseOperation"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.frontEndWarehouseOperation.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label:
                        _vm.elementDict.frontEndWarehouseOperation &&
                        _vm.elementDict.frontEndWarehouseOperation.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "frontEndWarehouseOperation",
                      "select-type":
                        _vm.selectTypeNames.basic_data_AirportCargoTerminal,
                      "method-params": { dataType: 1, deletionFlag: false },
                      filterable: "",
                      clearable: true,
                      "default-value": _vm.job.frontEndWarehouseOperation
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.frontEndWarehouseOperation = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedDateOfWarehousinge.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "estimatedDateOfWarehousinge" },
                  slot: "estimatedDateOfWarehousinge"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedDateOfWarehousinge.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedDateOfWarehousinge.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "66",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.estimatedDateOfWarehousinge,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "estimatedDateOfWarehousinge", $$v)
                      },
                      expression: "job.estimatedDateOfWarehousinge"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.estimatedDeliveryTime.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "estimatedDeliveryTime" },
                  slot: "estimatedDeliveryTime"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.estimatedDeliveryTime.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.estimatedDeliveryTime.label
                    },
                    slot: "label"
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "67",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss",
                      clearable: ""
                    },
                    model: {
                      value: _vm.job.estimatedDeliveryTime,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "estimatedDeliveryTime", $$v)
                      },
                      expression: "job.estimatedDeliveryTime"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.incoTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "incoTerm" }, slot: "incoTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.incoTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.incoTerm.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "68",
                      disabled: _vm.readonly,
                      "select-type": _vm.TYPE_NAMES.basic_data_IncoTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.job.incoTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.job.incoTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.bookingTerm.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "bookingTerm" }, slot: "bookingTerm" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.bookingTerm.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.bookingTerm.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "69",
                        clearable: false,
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.bookingTerm,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "bookingTerm", $$v)
                        },
                        expression: "job.bookingTerm"
                      }
                    },
                    _vm._l(_vm.bookingTerms, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.customClaim.visible
            ? _c(
                "template",
                { slot: "customClaim" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.customClaim.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.customClaim.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "70",
                          disabled: _vm.readonly,
                          filterable: "",
                          "select-type":
                            _vm.selectTypeNames
                              .local_cache_AirExportConstants$CUSTOM_CLAIMS,
                          "default-value": _vm.job.customClaim,
                          "tag-name": _vm.isZh ? "chineseName" : "englishName",
                          fields: ["chineseName"]
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.customClaim = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  Number(_vm.job.customClaim) === 1
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.CustomsDeclarationType")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "71",
                              disabled: _vm.readonly,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .basic_data_CustomsDeclarationType,
                              "default-value": _vm.job.customsClaim2 || 0
                            },
                            on: {
                              parentCallBack: function(p) {
                                _vm.job.customsClaim2 = p.value
                                _vm.job.customsDeclarationType = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoChineseName.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoChineseName" },
                  slot: "cargoChineseName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoChineseName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoChineseName.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "75",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.ChineseDescriptionOfGoods"),
                          _vm.job.cargoChineseName,
                          function(val) {
                            _vm.job.cargoChineseName = val
                          },
                          true,
                          { autoUppercase: true }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.cargoChineseName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cargoChineseName", $$v)
                      },
                      expression: "job.cargoChineseName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoEnglishName.visible
            ? _c(
                "el-form-item",
                {
                  attrs: { slot: "cargoEnglishName" },
                  slot: "cargoEnglishName"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.cargoEnglishName.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.cargoEnglishName.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "76",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.EnglishDescriptionOfGoods"),
                          _vm.job.cargoEnglishName,
                          function(val) {
                            _vm.job.cargoEnglishName = val
                          },
                          _vm.isUppercaseByConfig,
                          { autoUppercase: _vm.isUppercaseByConfig }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.cargoEnglishName,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "cargoEnglishName", $$v)
                      },
                      expression: "job.cargoEnglishName"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.mark.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "mark" }, slot: "mark" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.mark.isRequire ? "blue" : "",
                    attrs: { slot: "label", label: _vm.elementDict.mark.label },
                    slot: "label"
                  }),
                  _c("cargo-textarea", {
                    attrs: {
                      no: "77",
                      type: "textarea",
                      rows: 3,
                      disabled: !_vm.isEdit,
                      "auto-uppercase": _vm.isUppercaseByConfig
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Marks"),
                          _vm.job.mark,
                          function(val) {
                            _vm.job.mark = val
                          },
                          _vm.isUppercaseByConfig,
                          { autoUppercase: _vm.isUppercaseByConfig }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.mark,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "mark", $$v)
                      },
                      expression: "job.mark"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.cargoCode.visible
            ? _c(
                "template",
                { slot: "cargoCode" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.cargoCode.isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.cargoCode.label
                        },
                        slot: "label"
                      }),
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "78",
                          disabled: _vm.readonly,
                          "select-type":
                            _vm.TYPE_NAMES.basic_data_CargoInformation,
                          filterable: "",
                          "callback-params": { key: "cargoCode" },
                          "default-value": _vm.job.cargoCode,
                          placeholder: _vm.$t(
                            "queryJob.ClickSelectTheGoodsCode"
                          )
                        },
                        on: {
                          parentCallBack: _vm.txtCargoInformationChangeHandler
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: {
                          no: "79",
                          disabled: !_vm.job.cargoCode || _vm.readonly
                        },
                        model: {
                          value: _vm.job.cargoName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoName", $$v)
                          },
                          expression: "job.cargoName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.carryingCmp.visible && !_vm.isSalesForSzfs
            ? _c(
                "el-form-item",
                { attrs: { slot: "carryingCmp" }, slot: "carryingCmp" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.carryingCmp.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.carryingCmp.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "80",
                      disabled: !_vm.job.landTransportation || _vm.readonly,
                      "method-params": { truckCmp: true, active: true },
                      "default-value": _vm.job.carryingCmp || "",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseTickDoorLoadingDeliveryOption"
                      )
                    },
                    on: { change: _vm.carryingCmpChangeHandler }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.selling.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "selling" }, slot: "selling" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.selling.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.selling.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: { disabled: _vm.readonly, no: "81" },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.selling,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "selling", $$v)
                          },
                          expression: "job.selling"
                        }
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          filterable: "",
                          no: "sellingCurrency",
                          placeholder: " ",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Currency,
                          disabled: _vm.readonly,
                          "default-value": _vm.job.sellingCurrency,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.sellingCurrency = p.code
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.buying.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "buying" }, slot: "buying" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.buying.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.buying.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "120px", "margin-right": "5px" },
                        attrs: { disabled: _vm.readonly, no: "82" },
                        on: { blur: _vm.sellingOrBuyingChangeHandler },
                        model: {
                          value: _vm.job.buying,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "buying", $$v)
                          },
                          expression: "job.buying"
                        }
                      }),
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          filterable: "",
                          no: "buyingCurrency",
                          placeholder: " ",
                          "select-type":
                            _vm.selectTypeNames.basic_data_Currency,
                          disabled: _vm.readonly,
                          "default-value": _vm.job.buyingCurrency,
                          clearable: false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.job.buyingCurrency = p.code
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.sellPriceType &&
          _vm.elementDict.sellPriceType.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    slot: "sellPriceType",
                    label: _vm.elementDict.sellPriceType.label
                  },
                  slot: "sellPriceType"
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        placeholder: _vm.$t("Message.PleaseSelect"),
                        size: "mini",
                        no: "sellPriceType"
                      },
                      model: {
                        value: _vm.job.sellPriceType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "sellPriceType", $$v)
                        },
                        expression: "job.sellPriceType"
                      }
                    },
                    _vm._l(_vm.SELL_BUY_PRICE, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.buyPriceType && _vm.elementDict.buyPriceType.viewable
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    slot: "buyPriceType",
                    label: _vm.elementDict.buyPriceType.label
                  },
                  slot: "buyPriceType"
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        placeholder: _vm.$t("Message.PleaseSelect"),
                        size: "mini",
                        no: "buyPriceType"
                      },
                      model: {
                        value: _vm.job.buyPriceType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "buyPriceType", $$v)
                        },
                        expression: "job.buyPriceType"
                      }
                    },
                    _vm._l(_vm.SELL_BUY_PRICE, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label:
                            _vm.$store.getters.language === "zh"
                              ? item.chineseName
                              : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.doorName.visible && _vm.job.loadingTerm === "DD"
            ? _c(
                "el-form-item",
                { attrs: { slot: "doorName" }, slot: "doorName" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.doorName.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.doorName.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "83",
                        "value-key": "name",
                        clearable: "",
                        filterable: "",
                        "allow-create": true
                      },
                      on: { change: _vm.doorsChangeHandler },
                      model: {
                        value: _vm.truckingInfo.doorName,
                        callback: function($$v) {
                          _vm.$set(_vm.truckingInfo, "doorName", $$v)
                        },
                        expression: "truckingInfo.doorName"
                      }
                    },
                    _vm._l(_vm.doorList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.contactPerson.visible && _vm.job.loadingTerm === "DD"
            ? _c(
                "el-form-item",
                { attrs: { slot: "contactPerson" }, slot: "contactPerson" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.contactPerson.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.contactPerson.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "84",
                          placeholder: _vm.$t("Payment.contactPerson")
                        },
                        model: {
                          value: _vm.truckingInfo.doorMan,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorMan", $$v)
                          },
                          expression: "truckingInfo.doorMan"
                        }
                      }),
                      _c(
                        "div",
                        {
                          class: _vm.elementDict.contactPerson.isRequire
                            ? "blue"
                            : "",
                          staticStyle: {
                            width: "65px",
                            padding: "0 10px",
                            "font-size": "12px"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Tel")))]
                      ),
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          no: "85",
                          placeholder: _vm.$t("SeaExport.Tel")
                        },
                        model: {
                          value: _vm.truckingInfo.doorManTel,
                          callback: function($$v) {
                            _vm.$set(_vm.truckingInfo, "doorManTel", $$v)
                          },
                          expression: "truckingInfo.doorManTel"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.doorAddr.visible && _vm.job.loadingTerm === "DD"
            ? _c(
                "el-form-item",
                { attrs: { slot: "doorAddr" }, slot: "doorAddr" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.doorAddr.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.doorAddr.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "doorAddr",
                      type: "textarea",
                      rows: 3
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.doorAddr.label,
                          _vm.truckingInfo.doorAddr,
                          function(val) {
                            _vm.truckingInfo.doorAddr = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.truckingInfo.doorAddr,
                      callback: function($$v) {
                        _vm.$set(_vm.truckingInfo, "doorAddr", $$v)
                      },
                      expression: "truckingInfo.doorAddr"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.portOfDestinationServices.visible
            ? _c(
                "template",
                { slot: "portOfDestinationServices" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("line-label", {
                        class: _vm.elementDict.portOfDestinationServices
                          .isRequire
                          ? "blue"
                          : "",
                        attrs: {
                          slot: "label",
                          label: _vm.elementDict.portOfDestinationServices.label
                        },
                        slot: "label"
                      }),
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "dischargingPortDoor"
                          },
                          model: {
                            value: _vm.job.dischargingPortDoor,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "dischargingPortDoor", $$v)
                            },
                            expression: "job.dischargingPortDoor"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("SeaExport.DispatchVehiclesAtDestination")
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "usCustomsClearance"
                          },
                          model: {
                            value: _vm.job.usCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "usCustomsClearance", $$v)
                            },
                            expression: "job.usCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("queryJob.UsCustomsClearance")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-checkbox",
                        {
                          staticStyle: { display: "block" },
                          attrs: {
                            disabled: _vm.readonly,
                            no: "destPortCustomsClearance"
                          },
                          model: {
                            value: _vm.job.destPortCustomsClearance,
                            callback: function($$v) {
                              _vm.$set(_vm.job, "destPortCustomsClearance", $$v)
                            },
                            expression: "job.destPortCustomsClearance"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "SeaExport.PortOfDestinationCustomsClearance"
                              )
                            ) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.exChangeAgent.visible
            ? _c(
                "el-form-item",
                { attrs: { slot: "exChangeAgent" }, slot: "exChangeAgent" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.exChangeAgent.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.exChangeAgent.label
                    },
                    slot: "label"
                  }),
                  _c("cargo-company-select", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      no: "exChangeAgent",
                      disabled: !_vm.job.dischargingPortDoor || _vm.readonly,
                      "method-params": { bookingAgent: true, active: true },
                      "default-value": _vm.job.exChangeAgent || ""
                    },
                    on: { change: _vm.onExChangeAgentChange }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.elementDict.satisfiedRequests.visible,
                  expression: "elementDict.satisfiedRequests.visible"
                }
              ],
              staticClass: "auto-width",
              attrs: { slot: "satisfiedRequests" },
              slot: "satisfiedRequests"
            },
            [
              _c("special-requests-grid", {
                ref: "selectedSpecialRequest",
                attrs: {
                  no: "88",
                  "is-edit": _vm.isEdit,
                  "customer-id": _vm.job.customerId,
                  lob: _vm.job.lob,
                  job: _vm.job
                },
                model: {
                  value: _vm.job.satisfiedRequests,
                  callback: function($$v) {
                    _vm.$set(_vm.job, "satisfiedRequests", $$v)
                  },
                  expression: "job.satisfiedRequests"
                }
              })
            ],
            1
          ),
          _vm.elementDict.remarks.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "remarks" },
                  slot: "remarks"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.remarks.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.remarks.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "89",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        _vm.showAdvanceTextDialog(
                          _vm.$t("SeaExport.Remarks"),
                          _vm.job.remarks,
                          function(val) {
                            _vm.job.remarks = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.remarks,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "remarks", $$v)
                      },
                      expression: "job.remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField1.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "userDefinedField1" },
                  slot: "userDefinedField1"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField1.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField1.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "90",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField1.label,
                          _vm.job.userDefinedField1,
                          function(val) {
                            _vm.job.userDefinedField1 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField1,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField1", $$v)
                      },
                      expression: "job.userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField2.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "userDefinedField2" },
                  slot: "userDefinedField2"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField2.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField2.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "91",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField2.label,
                          _vm.job.userDefinedField2,
                          function(val) {
                            _vm.job.userDefinedField2 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField2,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField2", $$v)
                      },
                      expression: "job.userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField3.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "userDefinedField3" },
                  slot: "userDefinedField3"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField3.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField3.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "92",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField3.label,
                          _vm.job.userDefinedField3,
                          function(val) {
                            _vm.job.userDefinedField3 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField3,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField3", $$v)
                      },
                      expression: "job.userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.userDefinedField4.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "userDefinedField4" },
                  slot: "userDefinedField4"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.userDefinedField4.isRequire
                      ? "blue"
                      : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.userDefinedField4.label
                    },
                    slot: "label"
                  }),
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      no: "93",
                      type: "textarea",
                      rows: 4
                    },
                    nativeOn: {
                      dblclick: function($event) {
                        return _vm.showAdvanceTextDialog(
                          _vm.elementDict.userDefinedField4.label,
                          _vm.job.userDefinedField4,
                          function(val) {
                            _vm.job.userDefinedField4 = val
                          }
                        )
                      }
                    },
                    model: {
                      value: _vm.job.userDefinedField4,
                      callback: function($$v) {
                        _vm.$set(_vm.job, "userDefinedField4", $$v)
                      },
                      expression: "job.userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.taxNature && _vm.elementDict.taxNature.visible
            ? _c(
                "el-form-item",
                {
                  staticClass: "auto-width",
                  attrs: { slot: "taxNature" },
                  slot: "taxNature"
                },
                [
                  _c("line-label", {
                    class: _vm.elementDict.taxNature.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.taxNature.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "taxNature",
                        placeholder: _vm.$t("SeaExport.PleaseSelect")
                      },
                      model: {
                        value: _vm.job.taxNature,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "taxNature", $$v)
                        },
                        expression: "job.taxNature"
                      }
                    },
                    _vm._l(_vm.TAX_NATURES, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.elementDict.rateType && _vm.elementDict.rateType.slaveVisible
            ? _c(
                "el-form-item",
                { attrs: { slot: "rateType" }, slot: "rateType" },
                [
                  _c("line-label", {
                    class: _vm.elementDict.rateType.isRequire ? "blue" : "",
                    attrs: {
                      slot: "label",
                      label: _vm.elementDict.rateType.label
                    },
                    slot: "label"
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.readonly,
                        no: "rateType",
                        clearable: "",
                        placeholder: _vm.$t("SeaExport.PleaseSelect"),
                        size: "mini"
                      },
                      model: {
                        value: _vm.job.rateType,
                        callback: function($$v) {
                          _vm.$set(_vm.job, "rateType", $$v)
                        },
                        expression: "job.rateType"
                      }
                    },
                    _vm._l(_vm.rateType, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: _vm.isZh ? item.chineseName : item.englishName,
                          value: item.code
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _c("bill-address-dialog", {
        attrs: {
          visible: _vm.billAddressDialog.visible,
          job: _vm.job,
          "own-permission": _vm.hasChooseOwnTransceiverPermission,
          "customer-cmp-list": _vm.customerCmpList,
          "use-empty-customer-cmp-list": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.billAddressDialog, "visible", $event)
          },
          callback: _vm.codeSearchCallback
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "320px" },
            attrs: {
              disabled: _vm.readonly,
              "text-chars": _vm.advanceTextDialog.formatObj.maxChar,
              "warning-count": _vm.advanceTextDialog.formatObj.warningCount,
              "auto-uppercase": _vm.advanceTextDialog.formatObj.autoUppercase
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "transit-port-dialog",
          attrs: {
            visible: _vm.transitPortDialog.visible,
            title: _vm.$t("SeaExport.TransitInformation"),
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.transitPortDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "text-align": "center"
                  },
                  attrs: { span: 10, offset: 4 }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SecondCheck")))]
              ),
              _c(
                "el-col",
                {
                  staticStyle: {
                    "font-weight": "bold",
                    "text-align": "center"
                  },
                  attrs: { span: 10 }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ThreeWay")))]
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "5px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("To")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "94",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.transitPortDialog.form.secondPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.secondPortCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "95",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Airport,
                      "default-value": _vm.transitPortDialog.form.thirdPortCode
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.thirdPortCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("By")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "96",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      "default-value":
                        _vm.transitPortDialog.form.secondCarrierId || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.secondCarrierIdd =
                          p.value || 0
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "97",
                      filterable: "",
                      "select-type": _vm.TYPE_NAMES.basic_data_Company,
                      "method-params": { airCmp: true },
                      "default-value":
                        _vm.transitPortDialog.form.thirdCarrierId || ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.transitPortDialog.form.thirdCarrierId = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("Flight")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "98" },
                    model: {
                      value: _vm.transitPortDialog.form.secondFlight,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.transitPortDialog.form,
                          "secondFlight",
                          $$v
                        )
                      },
                      expression: "transitPortDialog.form.secondFlight"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "99" },
                    model: {
                      value: _vm.transitPortDialog.form.thirdFlight,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "thirdFlight", $$v)
                      },
                      expression: "transitPortDialog.form.thirdFlight"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [_vm._v("MAWB")]),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "100" },
                    model: {
                      value: _vm.transitPortDialog.form.secondMAWB,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "secondMAWB", $$v)
                      },
                      expression: "transitPortDialog.form.secondMAWB"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c("el-input", {
                    attrs: { no: "101" },
                    model: {
                      value: _vm.transitPortDialog.form.thirdMAWB,
                      callback: function($$v) {
                        _vm.$set(_vm.transitPortDialog.form, "thirdMAWB", $$v)
                      },
                      expression: "transitPortDialog.form.thirdMAWB"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "102", type: "primary" },
                  on: { click: _vm.confirmTransitPort }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "103" },
                  on: {
                    click: function($event) {
                      _vm.transitPortDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }